import React from "react";
import "./Header.css";
import Logo from "./Logo";
import { useCart } from "../../Modules/Hooks/useCart";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const Header = () => {
  const { totalItems } = useCart();

  return (
    <header className="Header--Container fade-in">
      <Link to="/" className="Header--Logo">
        <Logo />
      </Link>
      <div className="Header--Spacer" />
      <nav className="Header--Nav">
        <NavLink to="/about" className="Header--NavLink">
          О нас
        </NavLink>
        <NavLink to="/cart" className="Header--NavLink Header--CartLink">
          <ShoppingCart size={20} />
          {totalItems > 0 && <span className="Cart--Count">{totalItems}</span>}
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;
